// ============================================================================
// Spacing Visualization — Color & Style Constants
// ============================================================================

export const SPACING_VIZ_COLORS = {
  margin: 'rgba(237,137,54,0.15)',
  padding: 'rgba(72,187,120,0.15)',
  content: 'rgba(66,153,225,0.4)',
  gap: 'rgba(159,122,234,0.25)',
  labelBg: 'rgba(37,40,48,0.9)',
  labelText: 'rgba(255,255,255,0.8)',
  labelZero: 'rgba(255,255,255,0.4)',
} as const;
